import { APP_TRANSACTION, TRANSACTION_HISTORY } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IOTSimRegistrationRequestModel } from "features/iotSimRegistration/data/model/IOTSimRegistrationRequestModel";
import { IOTSimRegistrationResponseModel } from "features/iotSimRegistration/data/model/IOTSimRegistrationResponseModel";
import { IIOTSimRegistrationRepository } from "features/iotSimRegistration/domain/repositories/IIOTSimRegistrationRepository";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";

@injectable()
export class IOTSimRegistrationImpl implements IIOTSimRegistrationRepository {
  async getList(
    params: IOTSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<IOTSimRegistrationResponseModel>> {
    const url = StringFormat.buildListUrl<IOTSimRegistrationRequestModel>(
      TRANSACTION_HISTORY.IOTSIMLIST,
      params
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getDetail(
    params: IOTSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<IOTSimRegistrationResponseModel>> {
    return await client.get(
      `${TRANSACTION_HISTORY.IOTSIMLIST}/${params?.["code"]}`
    );
  }

  async exportReport(
    params: IOTSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      TRANSACTION_HISTORY.IOTSIMLIST,
      params
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }

  async checkStatus(
    code: string
  ): Promise<BaseApiResponseModel<IOTSimRegistrationResponseModel>> {
    return await client?.get(APP_TRANSACTION?.CHECK_STATUS, { code });
  }
}
